const styles = (theme) => ({
  main: {
    padding: theme.spacing(3)
  },
  card: { width: '100%' },
  errorAlert: { maxWidth: '600px', marginTop: 20 }
});

export default styles;
